"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./NavBarTop.scss");
var _iconSearch = _interopRequireDefault(require("../../images/icon-search.svg"));
var _utilizeFocus = require("../../utils/utilizeFocus");
var _NavBar = require("../NavBar/NavBar");
var _NavSearch = _interopRequireDefault(require("../NavSearch/NavSearch"));
var _LanguageSelector = _interopRequireDefault(require("../LanguageSelector/LanguageSelector"));
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const NavBarTop = props => {
  const {
    searchField,
    disableLogin = true,
    rightLinks,
    Link,
    divisionName,
    logo,
    disableSearch,
    placeholder,
    handleSearchFieldChange,
    disableLanguageRegion = true,
    regionLanguageID,
    children,
    hamburgerIsOpen,
    disableSectorFlyOut,
    languageSelectorData,
    languageSelectorDeployed,
    handleLanguageSelectorDeployed,
    saveLanguage,
    searchComponent,
    searchDeployed,
    setSearchDeployed,
    displaySectorName,
    theme,
    setDesktopSearchDeployed,
    desktopSearchDeployed,
    globalSearch,
    setGlobalSearch
  } = props;
  const inputFocus = (0, _utilizeFocus.utilizeFocus)();
  const logoRef = (0, _react.useRef)();
  const {
    mouse,
    handleSearchSubmit,
    hamburgerClick,
    closeAllDropDowns,
    handleSectorFlyoutDeployed,
    closeHamburger
  } = (0, _react.useContext)(_NavBar.NavBarContext);
  const [searchState, setSearchState] = (0, _react.useState)(null);
  const [largeLogo, setLargeLogo] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (logoRef?.current?.offsetWidth > 240) {
      setLargeLogo(true);
    }
  }, [logoRef]);
  const toggleDesktopSearch = isDesktop => {
    if (!desktopSearchDeployed) {
      handleSectorFlyoutDeployed(false);
      handleLanguageSelectorDeployed(false);
      closeAllDropDowns();
      setSearchDeployed(true);
      setGlobalSearch && setGlobalSearch(false);
      setDesktopSearchDeployed(true);
      if (!mouse) {
        if (isDesktop) {
          setTimeout(() => {
            document?.getElementById("desktop-nav-button")?.focus();
          }, 100);
        } else {
          setTimeout(() => {
            document?.getElementById("mobile-nav-button")?.focus();
          }, 100);
        }
      }
    } else if (searchField.length > 0) {
      handleSearchSubmit();
      setSearchDeployed(false);
      setDesktopSearchDeployed(false);
    } else {
      setSearchDeployed(false);
      setDesktopSearchDeployed(false);
    }
  };
  const renderClassNamesForFocus = (0, _react.useMemo)(() => {
    if (!disableLogin && mouse) {
      return "ter-navbar-top__link active";
    } else if (disableLogin && mouse) {
      return "ter-navbar-top__link";
    } else if (!disableLogin && !mouse) {
      return "ter-navbar-top__link tabFocus";
    }
  }, [disableLogin, mouse]);
  const generateRightLinks = () => {
    return rightLinks?.filter(link => link?.url)?.map(link => {
      const {
        url,
        text
      } = link;
      return /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
        tabIndex: mouse ? "" : "0",
        key: text,
        to: url,
        style: {
          textDecoration: "none"
        },
        className: renderClassNamesForFocus,
        Link: Link,
        "aria-label": `Link to ${text}`
      }, text);
    });
  };
  const mouseOverSearch = () => {
    setSearchState("hover");
  };
  const mouseLeaveSearch = () => {
    setSearchState(null);
  };
  const getSearchStatus = () => {
    if (searchState === "hover") {
      return "hover";
    } else if (desktopSearchDeployed) {
      return "deployed";
    } else {
      return "default";
    }
  };
  const handleToggleWithKeyBoard = event => {
    if (!mouse) {
      // checks that a user hits the enter key to open the modal
      if (event?.keyCode === 13) {
        handleLanguageSelectorDeployed();
      }
    }
  };
  const openSearchWithEnter = (event, isDesktop) => {
    if (!mouse) {
      // checks that a user hits the enter key to open the modal
      if (event?.keyCode === 13) {
        toggleDesktopSearch(isDesktop);
      }
    }
  };
  const simulateHamburgerClickWithEnter = event => {
    if (!mouse) {
      // checks that a user hits the enter key to open the modal
      if (event?.keyCode === 13) {
        hamburgerClick();
      }
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `luna-layout__navigation-padding ${theme ? `luna-layout__navigation-padding--${theme}` : ""}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-navbar-top__wrapper ${theme ? `ter-navbar-top__wrapper--${theme}` : ""}`
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-navbar-top ${disableSectorFlyOut ? "" : "ter-navbar-top--flyout"}
          ${theme ? `ter-navbar-top--${theme}` : ""}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-navbar-top__left ${desktopSearchDeployed ? "ter-navbar-top__left--search-active" : ""}`
  }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    role: "tab",
    tabIndex: mouse ? "" : "0",
    className: `ter-navbar-top__logo-link ${mouse ? "" : "tabFocus"}`,
    to: logo?.link?.url,
    Link: Link,
    onKeyDown: e => handleToggleWithKeyBoard(e),
    "aria-label": "Link to homepage"
  }, /*#__PURE__*/_react.default.createElement("img", {
    ref: logoRef,
    className: `${mouse ? "ter-navbar-top__logo" : "ter-navbar-top__logo tabFocus"} ${largeLogo === true ? "ter-navbar-top__logo--large" : ""}
                `,
    src: logo?.url,
    alt: logo?.altText ? logo?.altText : ""
  }), (divisionName && divisionName) !== "Global" && /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-navbar-top__division-name"
  }, divisionName))), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-navbar-top__right"
  }, !disableSearch && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("figure", {
    className: `ter-navbar-top__search-wrapper ter-navbar-top__search-wrapper--${getSearchStatus()} ${mouse ? "" : "tabFocus"}`,
    role: "none",
    tabIndex: mouse ? "" : "0",
    onClick: () => {
      toggleDesktopSearch(true);
    },
    onMouseOver: mouseOverSearch,
    onMouseLeave: mouseLeaveSearch,
    onKeyDown: e => {
      openSearchWithEnter(e, true);
      //Sets the user's focus to the search field when activated by the enter key
      inputFocus.setFocus();
    },
    "aria-label": `Search Trimble ${divisionName}`,
    "aria-expanded": desktopSearchDeployed,
    "aria-controls": `${divisionName}-search-input-field`
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "ter-navbar-top__search",
    src: _iconSearch.default,
    alt: "magnifying glass"
  })), /*#__PURE__*/_react.default.createElement(_NavSearch.default, {
    deployed: desktopSearchDeployed,
    toggleDesktopSearch: toggleDesktopSearch,
    searchComponent: searchComponent,
    mouse: mouse,
    isDesktop: true
  }), !!rightLinks?.length && /*#__PURE__*/_react.default.createElement("span", {
    className: "ter-navbar-top__pipe"
  }, "|")), generateRightLinks(), !disableLanguageRegion && languageSelectorData?.languages && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "ter-navbar-top__pipe"
  }, "|"), /*#__PURE__*/_react.default.createElement("div", {
    tabIndex: mouse ? "" : "0",
    className: `ter-navbar-top__location ${mouse ? "" : "tabFocus"}`,
    onKeyDown: e => handleToggleWithKeyBoard(e),
    "aria-label": `${languageSelectorData?.settings?.region} ${languageSelectorData?.settings?.language?.nativeField}
                    : Change region or language`,
    "aria-expanded": languageSelectorDeployed,
    "aria-controls": regionLanguageID
  }, /*#__PURE__*/_react.default.createElement(_LanguageSelector.default, {
    labels: languageSelectorData?.labels,
    settings: languageSelectorData?.settings,
    languages: languageSelectorData?.languages,
    regions: languageSelectorData?.regions,
    languageSelectorDeployed: languageSelectorDeployed,
    saveLanguage: saveLanguage,
    handleLanguageSelectorDeployed: handleLanguageSelectorDeployed
  }))), children), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-navbar-top__mobile-search-hamburger-wrapper"
  }, !disableSearch && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-navbar-top__mobile-search-wrapper"
  }, /*#__PURE__*/_react.default.createElement("figure", {
    className: `ter-navbar-top__search-wrapper ter-navbar-top__search-wrapper--${getSearchStatus()} ${mouse ? "" : "tabFocus"}`,
    role: "none",
    tabIndex: mouse ? "" : "0",
    onClick: () => {
      toggleDesktopSearch(false);
      if (hamburgerIsOpen) {
        closeHamburger();
      }
    },
    onMouseOver: mouseOverSearch,
    onMouseLeave: mouseLeaveSearch,
    onKeyDown: e => {
      openSearchWithEnter(e, false);
      //Sets the user's focus to the search field when activated by the enter key
      inputFocus.setFocus();
    },
    "aria-label": `Search Trimble ${divisionName}`,
    "aria-expanded": desktopSearchDeployed,
    "aria-controls": `${divisionName}-search-input-field`
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "ter-navbar-top__search",
    src: _iconSearch.default,
    alt: "magnifying glass"
  })), /*#__PURE__*/_react.default.createElement(_NavSearch.default, {
    deployed: desktopSearchDeployed,
    toggleDesktopSearch: toggleDesktopSearch,
    searchComponent: searchComponent,
    mouse: mouse,
    isDesktop: false
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-navbar-top__right--mobile ${hamburgerIsOpen ? "ter-navbar-top__right--mobile--is-open" : ""}  ${mouse ? "" : "tabFocus"}`,
    tabIndex: mouse ? "" : "0",
    onClick: () => {
      hamburgerClick();
      if (desktopSearchDeployed) {
        toggleDesktopSearch(false);
      }
    },
    onKeyDown: e => simulateHamburgerClickWithEnter(e)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-navbar-top__hamburger-and-login-container"
  }, children, /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-navbar-top__right--mobile-hamburger ${hamburgerIsOpen ? "ter-navbar-top__right--mobile-hamburger--is-open" : ""}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-navbar-top__right--mobile-hamburger-top ${theme ? `ter-navbar-top__right--mobile-hamburger-top--${theme}` : ""}`
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-navbar-top__right--mobile-hamburger-middle ${theme ? `ter-navbar-top__right--mobile-hamburger-middle--${theme}` : ""}`
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-navbar-top__right--mobile-hamburger-bottom ${theme ? `ter-navbar-top__right--mobile-hamburger-bottom--${theme}` : ""}`
  })))))))));
};
var _default = NavBarTop;
exports.default = _default;